import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  UncontrolledTooltip,
} from "reactstrap";
import { Link } from "react-router-dom";
import Select from "react-select";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import * as Yup from "yup";

const SelectcustomStyles = {
  control: (base) => ({
    ...base,
    minHeight: 33.1,
  }),
  indicatorsContainer: (base) => ({
    ...base,
    padding: "0",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "2px 8px",
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: "2px 8px",
  }),
};

const YearlySlabFixing = () => {
  const [data, setData] = useState([
    { id: 1, financialYear: "2024-2025", department: "Admin", fromDate: "01.04.24", toDate: "31.03.25", percentage: "70.00", allowances: "HRA, (BASIC + DA)", isActive: true },
    { id: 2, financialYear: "2024-2025", department: "STORE", fromDate: "01.04.24", toDate: "31.03.25", percentage: "70.00", allowances: "HRA, (BASIC + DA)", isActive: true },
    { id: 3, financialYear: "2024-2025", department: "CUTTING", fromDate: "01.04.24", toDate: "31.03.25", percentage: "70.00", allowances: "HRA, (BASIC + DA)", isActive: true },
    { id: 4, financialYear: "2024-2025", department: "QUALITY CONTROL", fromDate: "01.04.24", toDate: "31.03.25", percentage: "70.00", allowances: "HRA, (BASIC + DA)", isActive: true },
    { id: 5, financialYear: "2024-2025", department: "ANCILLARY", fromDate: "01.04.24", toDate: "31.03.25", percentage: "70.00", allowances: "HRA, (BASIC + DA)", isActive: true },
    { id: 6, financialYear: "2024-2025", department: "EMBROIDERY", fromDate: "01.04.24", toDate: "31.03.25", percentage: "70.00", allowances: "HRA, (BASIC + DA)", isActive: true },
    { id: 7, financialYear: "2024-2025", department: "PACKING", fromDate: "01.04.24", toDate: "31.03.25", percentage: "70.00", allowances: "HRA, (BASIC + DA)", isActive: true },
    { id: 8, financialYear: "2024-2025", department: "DESPATCH", fromDate: "01.04.24", toDate: "31.03.25", percentage: "70.00", allowances: "HRA, (BASIC + DA)", isActive: true },
    { id: 9, financialYear: "2024-2025", department: "SEWING", fromDate: "01.04.24", toDate: "31.03.25", percentage: "70.00", allowances: "HRA, (BASIC + DA)", isActive: true },
    { id: 10, financialYear: "2024-2025", department: "CHECKING", fromDate: "01.04.24", toDate: "31.03.25", percentage: "70.00", allowances: "HRA, (BASIC + DA)", isActive: true },
  ]);

  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  const financialYearOptions = [
    { value: "2024-2025", label: "2024-2025" },
  ];

  const departmentOptions = [
    { value: "Admin", label: "Admin" },
    { value: "STORE", label: "STORE" },
    { value: "CUTTING", label: "CUTTING" },
    { value: "QUALITY CONTROL", label: "QUALITY CONTROL" },
    { value: "ANCILLARY", label: "ANCILLARY" },
    { value: "EMBROIDERY", label: "EMBROIDERY" },
    { value: "PACKING", label: "PACKING" },
    { value: "DESPATCH", label: "DESPATCH" },
    { value: "SEWING", label: "SEWING" },
    { value: "CHECKING", label: "CHECKING" },
  ];

  const allowancesOptions = [
    { value: "(BASIC + DA)", label: "(BASIC + DA)" },
    { value: "HRA", label: "HRA" },
    { value: "CONVEYANCE", label: "CONVEYANCE" },
    { value: "WASHING", label: "WASHING" },
    { value: "Fuel", label: "Fuel" },
    { value: "OT", label: "OT" },
    { value: "Travel", label: "Travel" },
  ];


  const formik = useFormik({
    initialValues: {
      financialYear: "",
      department: "",
      fromDate: "",
      toDate: "",
      percentage: "",
      allowances: [],
    },
    validationSchema: Yup.object({
      financialYear: Yup.string().required("Financial Year is Required"),
      department: Yup.string().required("Department is Required"),
      percentage: Yup.string().required("Percentage is Required"),
      allowances: Yup.array().min(1, "Allowances is Required"),
    }),
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit: (values, { resetForm }) => {
      if (isEdit) {
        setData(prevData =>
          prevData.map(item =>
            item.id === editId ? {
              ...item,
              financialYear: values.financialYear,
              department: values.department,
              percentage: values.percentage,
              allowances: values.allowances.join(", "),
            } : item
          )
        );
        setIsEdit(false);
        setEditId(null);
      } else {
        const newRow = {
          id: data.length + 1,
          financialYear: values.financialYear,
          department: values.department,
          fromDate: "01.04.24",
          toDate: "31.03.25",
          percentage: values.percentage,
          allowances: values.allowances.join(", "),
          isActive: true,
        };
        setData(prev => [...prev, newRow]);
      }

      resetForm({
        values: {
          financialYear: "",
          department: "",
          fromDate: "",
          toDate: "",
          percentage: "",
          allowances: [],
        },
        touched: {},
        errors: {}
      });

    }
  });


  const handleEdit = (row) => {
    formik.setValues({
      financialYear: row.financialYear,
      department: row.department,
      fromDate: row.fromDate,
      toDate: row.toDate,
      percentage: row.percentage,
      allowances: row.allowances.split(", ").map(item => item.trim()),
    });
    setIsEdit(true);
    setEditId(row.id);
  };

  const columns = [
    {
      Header: "S.No", Cell: ({ row }) => data.length - row.index, className: "serial-no",
      applyHeaderClass: true,
    },
    { Header: "Financial Year", accessor: "financialYear" },
    { Header: "Department", accessor: "department" },
    { Header: "From Date", accessor: "fromDate" },
    { Header: "To Date", accessor: "toDate" },
    { Header: "Percentage", accessor: "percentage" },
    { Header: "Allowances", accessor: "allowances" },
    {
      Header: "Edit",
      className: "serial-no",
      applyHeaderClass: true,
      Cell: (cellProps) => (
        <Link to="#" className="text-success" onClick={() => handleEdit(cellProps.row.original)}>
          <i className="bx bxs-edit font-size-18" id={`edit-tooltip-${cellProps.row.id}`} />
          <UncontrolledTooltip placement="top" target={`edit-tooltip-${cellProps.row.id}`}>
            Edit
          </UncontrolledTooltip>
        </Link>
      ),
    },
    {
      Header: "Status",
      className: "status-col",
      applyHeaderClass: true,
      Cell: (cellProps) => {
        const isActive = cellProps.row.original.isActive;
        return (
          <Link to="#" style={{ color: isActive ? "green" : "red" }}>
            <i
              className={`mdi ${isActive ? "mdi-check-circle" : "mdi-close-circle"} font-size-18`}
              id={`status-tooltip-${cellProps.row.id}`}
            />
            <UncontrolledTooltip placement="top" target={`status-tooltip-${cellProps.row.id}`}>
              {isActive ? "Active" : "Inactive"}
            </UncontrolledTooltip>
          </Link>
        );
      },
    },
  ];

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Performance" breadcrumbItem="Yearly Slab Fixing" />
        <Card>
          <CardBody>
            <Form onSubmit={formik.handleSubmit}>
              <Row>
                <Col lg={3} sm={6}>
                  <FormGroup>
                    <Label>Financial Year <span className="text-danger">*</span></Label>
                    <Select
                      options={financialYearOptions}
                      onChange={(selected) => formik.setFieldValue("financialYear", selected.value)}
                      onBlur={() => formik.setFieldTouched("financialYear", true)}
                      value={formik.values.financialYear ? financialYearOptions.find(opt => opt.value === formik.values.financialYear) : null}
                      styles={SelectcustomStyles}
                      className="hrms-select"
                      classNamePrefix="hrms-select"
                    />
                    {formik.touched.financialYear && formik.errors.financialYear && (
                      <div className="text-danger">{formik.errors.financialYear}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col lg={3} sm={6}>
                  <FormGroup>
                    <Label>Department <span className="text-danger">*</span></Label>
                    <Select
                      options={departmentOptions}
                      onChange={(selected) => formik.setFieldValue("department", selected.value)}
                      onBlur={() => formik.setFieldTouched("department", true)}
                      value={formik.values.department ? departmentOptions.find(opt => opt.value === formik.values.department) : null}
                      styles={SelectcustomStyles}
                      className="hrms-select"
                      classNamePrefix="hrms-select"
                    />
                    {formik.touched.department && formik.errors.department && (
                      <div className="text-danger">{formik.errors.department}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col lg={3} sm={6}>
                  <FormGroup>
                    <Label>Percentage <span className="text-danger">*</span></Label>
                    <Input
                      type="number"
                      name="percentage"
                      value={formik.values.percentage}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={formik.touched.percentage && formik.errors.percentage ? "is-invalid" : ""}
                    />
                    {formik.touched.percentage && formik.errors.percentage && (
                      <div className="text-danger">{formik.errors.percentage}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col lg={3} sm={6}>
                  <FormGroup>
                    <Label>Allowances <span className="text-danger">*</span></Label>
                    <Select
                      options={allowancesOptions}
                      isMulti
                      onChange={(selected) => formik.setFieldValue("allowances", selected.map(opt => opt.value))}
                      onBlur={() => formik.setFieldTouched("allowances", true)}
                      value={allowancesOptions.filter(opt => formik.values.allowances.includes(opt.value))}
                      styles={SelectcustomStyles}
                      className="hrms-select"
                      classNamePrefix="hrms-select"
                    />
                    {formik.touched.allowances && formik.errors.allowances && (
                      <div className="text-danger">{formik.errors.allowances}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md="12" className="text-end">
            
                  <Button type="submit" className="btn button-save me-2">
                    <i className="fas fa-save me-1" /> {isEdit ? "Update" : "Save"}
                  </Button>
                  <Button type="button" className="button-cancel" color="secondary" onClick={() => {
                    formik.resetForm({
                      values: {
                        financialYear: "",
                        department: "",
                        fromDate: "",
                        toDate: "",
                        percentage: "",
                        allowances: [],
                      },
                      touched: {},
                      errors: {}
                    });
                    setIsEdit(false);
                    setEditId(null);
                    className="btn button-cancel"
                  }}>
                   <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainer columns={columns} data={data} isGlobalFilter={true} customPageSize={10} />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default YearlySlabFixing;
